import BoldDecorator from "./bold/viewer.js";
import FontSizeDecorator from "./font-size/viewer.js";
import ItalicDecorator from "./italic/viewer.js";
import UnderlineDecorator from "./underline/viewer.js";
const nodeViewDecorators = [
  BoldDecorator,
  ItalicDecorator,
  UnderlineDecorator,
  FontSizeDecorator
];
export {
  nodeViewDecorators
};
//# sourceMappingURL=viewer.js.map
